import { REGISTER_RESOURCE, RegisterResourceAction } from "ra-core"
import { call, delay, fork, put, select, take } from "redux-saga/effects"
import { UserResponseDto } from "@/gen/api/user"
import { userApiClient } from "@/lib/client"
import { getUserProfile } from "@/reducers/userProfile"
import { promiseWithResolvers } from "@/utils/promiseWithResolvers"
import { CallReturnType } from "@/utils/sagaTypsHelper"


let deferredResult: Promise<UserResponseDto|undefined>|null = null

export const ensureUserProfile = () => {
  const bag = promiseWithResolvers<UserResponseDto|undefined>()

  function* ensureUserProfileSaga() {
    let userProfile: UserResponseDto|undefined = yield select(getUserProfile)
    
    if (!userProfile) {
      if (!deferredResult) {
        const { resolve, promise } = promiseWithResolvers<UserResponseDto|undefined>()
        deferredResult = promise
        const getUserProfileFn = userApiClient.apiUsersProfileGet.bind(userApiClient)
        const data: CallReturnType<typeof getUserProfileFn> = yield call<typeof getUserProfileFn>(getUserProfileFn)
        
        userProfile = data.data
        if (userProfile) {
          yield fork(syncUserProfileToStore, userProfile)
        }
        resolve(userProfile)
        yield fork(cleanDeferredResult)
      } else {
        const d = deferredResult
        userProfile = yield d  
      }
    }
    bag.resolve(userProfile)
  }
  return {ensureUserProfileSaga, userProfileDeferred: bag.promise }
}


function* syncUserProfileToStore(userProfile: UserResponseDto) {
  const profileResReady: boolean = yield select((state: any) => !!(state?.admin?.resources?.profile))
  const syncAction = {
    type: "OD/USER_PROFILE_INFO_SYNC_SUCCESS",
    payload: { data: { ...userProfile, id: 'edit' }},
    requestPayload: { id: 'edit'},
    meta: {
        resource: 'profile',
        fetchResponse: 'GET_ONE',
        fetchStatus: 'RA/FETCH_END',
    },
  }

  if (profileResReady) {
    // here is a hack, we trick ra's reducer into thinking that a profile resource has been GET
    yield put(syncAction)
  }

  const profileRegisterAction: RegisterResourceAction = 
    yield take((action: any) => 
      action.type === REGISTER_RESOURCE && 
      action.payload?.name === 'profile')

  if (profileRegisterAction) {
    yield put(syncAction)
  }
}

function* cleanDeferredResult() {
  yield delay(100)
  deferredResult = null
}